import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderFour from "../common/header/HeaderFour";
import FooterOne from "../common/footer/FooterOne";
import GoogleSignUp from "./SignupProcess/GoogleSignUp";
import OtpVerification from "./SignupProcess/OtpVerification";
import PersonalInfoForm from "./SignupProcess/PersonalInfoForm";
import EducationForm from "./SignupProcess/EducationForm";
import EmploymentForm from "./SignupProcess/EmploymentForm";
import AdditionalInfoForm from "./SignupProcess/AdditionalInfoForm";
import CLIFLoader from "../elements/loader/ClifLoader";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import SEO from "../common/SEO";

const customSelectStyles = {
  // Your existing styles here - unchanged
  control: (provided) => ({
    ...provided,
    minHeight: "38px",
    height: "38px",
    border: "1px solid #ced4da",
    borderRadius: "0.375rem",
    boxShadow: "none",
    backgroundColor: "#fff",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    "&:hover": {
      border: "1px solid #ced4da",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px", // Adjusted padding
    height: "36px",
    display: "flex",
    alignItems: "center",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    height: "36px",
    position: "absolute",
  }),
  placeholder: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    margin: "0",
    color: "#6c757d",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    margin: "0",
    padding: "0",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 8px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    position: "absolute",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "150px",
    overflowY: "auto",
    padding: 0,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1rem",
    padding: "0.5rem 0.75rem",
    color: "#000",
    cursor: "pointer",
  }),
};

const firebaseConfig = {
  apiKey: "AIzaSyBAMtvrbKK1p7hTG1V2AYz2bpGpGDcUAMQ",
  authDomain: "clifai-cd683.firebaseapp.com",
  projectId: "clifai-cd683",
  storageBucket: "clifai-cd683.firebasestorage.app",
  messagingSenderId: "1001395506359",
  appId: "1:1001395506359:web:a819d14200c1de7aae5132",
  measurementId: "G-YH75BT5LTN",
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const SignUp = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();

  // Get subscription details from location state
  const selectedPlan = location.state?.selectedPlan || null;
  const careerLaunch = location.state?.careerLaunch || false;
  const [isCareerLaunch, setIsCareerLaunch] = useState(careerLaunch);

  // Format subscription data from pricing page
  const subscriptionData = selectedPlan
    ? {
        plan: selectedPlan.name || "FREE MVP TRIAL",
        price: selectedPlan.price || "₹0",
        duration: selectedPlan.duration || "3 days",
        features: selectedPlan.features || [],
        priceId: selectedPlan.priceId || null,
        paymentId: null, // Will be populated after payment
      }
    : null;

  const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    cpassword: "",
    otp: "",
    education: "",
    yearOfCompletion: "",
    specialization: "",
    current_employer: "",
    currentRole: "",
    desired_employer: "",
    desiredRole: "",
    desired_country: "",
    fileUpload: "",
    job_goal: "",
    age: "",
    gender: "",
    headshot: "",
    country: "",
    fileLocation: "",
    // Subscription fields
    subscriptionPlan: subscriptionData?.plan || "FREE MVP TRIAL",
    subscriptionPrice: subscriptionData?.price || "₹0",
    subscriptionDuration: subscriptionData?.duration || "3 days",
    paymentId: subscriptionData?.paymentId || null,
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [googleVerified, setGoogleVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  // Refs for all mandatory fields across forms
  const allInputRefs = {
    firstname: useRef(null),
    lastname: useRef(null),
    age: useRef(null),
    gender: useRef(null),
    country: useRef(null),
    education: useRef(null),
    specialization: useRef(null),
    current_employer: useRef(null),
    currentRole: useRef(null),
    desired_employer: useRef(null),
    desiredRole: useRef(null),
    desired_country: useRef(null),
    fileUpload: useRef(null),
    job_goal: useRef(null),
    clif_check: useRef(null),
  };

  // Check if the user navigated from pricing and show subscription popup
  useEffect(() => {
    if (selectedPlan) {
      console.log("Selected plan received:", selectedPlan);
      setShowSubscriptionPopup(true);

      // Update form with subscription data
      setFormValues((prev) => ({
        ...prev,
        subscriptionPlan: selectedPlan.name || prev.subscriptionPlan,
        subscriptionPrice: selectedPlan.price || prev.subscriptionPrice,
        subscriptionDuration:
          selectedPlan.duration || prev.subscriptionDuration,
      }));
    } else {
      // If no plan is selected, redirect to pricing
      // Commented out to avoid forced redirection during development
      // navigate("/pricing");
    }
  }, [selectedPlan, navigate]);

  const validateStep = (step) => {
    const errors = {};

    switch (step) {
      case 1: // Personal Information
        if (!formValues.firstname.trim())
          errors.firstname = "First name is required";
        if (!formValues.lastname.trim())
          errors.lastname = "Last name is required";
        if (!formValues.age.trim()) errors.age = "Age group is required";

        if (!formValues.country.trim()) errors.country = "Country is required";
        if (formValues.country) {
          if (formValues.country !== "IN" && formValues.country !== "US") {
            errors.country =
              "CLIF AI is only operating in India and USA for now ";
          }
        }
        if (!formValues.clif_check) {
          if (!formValues.job_goal) {
            errors.job_goal = "Dream job goal is required";
          }
        }
        if (formValues.job_goal) {
          if (formValues.job_goal.trim().length < 50) {
            errors.job_goal =
              "Dream Job Goal should be at least 50 characters long";
          } else if (formValues.job_goal.trim().length > 250) {
            errors.job_goal =
              "Dream Job Goal should be at most 250 characters long";
          }
        }
        if (!formValues.clif_check) {
          if (!formValues.fileUpload) {
            errors.fileUpload = "Resume is required for CLIF suggestion";
          }
        }
        if (!formValues.fileUpload) {
          errors.fileUpload = "Resume is required";
        }
        break;

      case 2: // Education
        if (!formValues.education.trim())
          errors.education = "Education level is required";
        if (!formValues.specialization.trim())
          errors.specialization = "Specialization is required";
        if (careerLaunch === false) {
          if (!formValues.current_employer.trim())
            errors.current_employer = "Current employer is required";
          if (!formValues.currentRole.trim())
            errors.currentRole = "Current role is required";
        }
        break;

      case 3: // Employment
        if (!formValues.desired_employer.trim())
          errors.desired_employer = "Desired employer is required";
        if (!formValues.desiredRole.trim())
          errors.desiredRole = "Desired role is required";
        if (!formValues.desired_country.trim())
          errors.desired_country = "Desired country is required";
        break;

      default:
        break;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep((prev) => prev + 1);
      setFormErrors({});
    } else {
      const firstErrorField = Object.keys(formErrors)[0];
      console.log(firstErrorField);
      if (firstErrorField && allInputRefs[firstErrorField]?.current) {
        allInputRefs[firstErrorField].current.focus();
        allInputRefs[firstErrorField].current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
    setFormErrors({});
  };

  const renderStepIndicator = () => {
    if (!otpVerified) return null;

    return (
      <div className="step-indicator mb-4 mt-n4">
        <div className="row justify-content-center">
          <h3 className="text-center">Help CLIF Know You Better</h3>
          <div className="col text-center">
            <div className={`step-circle ${currentStep >= 1 ? "active" : ""}`}>
              1
            </div>
            <div className="step-label">Personal Information</div>
          </div>
          <div className="col text-center">
            <div className={`step-circle ${currentStep >= 2 ? "active" : ""}`}>
              2
            </div>
            <div className="step-label">Your Highest Qualification</div>
          </div>
          <div className="col text-center">
            <div className={`step-circle ${currentStep >= 3 ? "active" : ""}`}>
              3
            </div>
            <div className="step-label">Employment Details</div>
          </div>
        </div>
      </div>
    );
  };

  // Function to render the subscription popup
  const renderSubscriptionPopup = () => {
    if (!subscriptionData || !showSubscriptionPopup) return null;

    return (
      <div className="subscription-popup-overlay mt-5 h-100">
        <div className="subscription-popup mt-5">
          <div className="subscription-popup-content">
            <div className="plan-highlight">
              <h5 className="plan-name">
                SELECTED PLAN : {subscriptionData.plan}
              </h5>
              <div className="plan-price">{subscriptionData.price}</div>
              <div className="plan-duration">{subscriptionData.duration}</div>
            </div>

            {subscriptionData.features &&
              subscriptionData.features.length > 0 && (
                <div className="features-section-popup">
                  <h6>What You Get:</h6>
                  <div className="features-list">
                    {subscriptionData.features.map((feature, index) => (
                      <div key={index} className="feature-item-popup">
                        <span className="feature-check-popup">✓</span>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            <div className="popup-actions">
              <button
                type="button"
                className="btn-continue-registration text-white"
                style={{ backgroundColor: "#6600CC" }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#006600";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#6600CC";
                }}
                onClick={() => setShowSubscriptionPopup(false)}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Function to render the appropriate form based on current step
  const renderFormByStep = () => {
    if (!otpVerified) {
      return !otpSent ? (
        <GoogleSignUp
          formValues={formValues}
          setFormValues={setFormValues}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          setOtpSent={setOtpSent}
          setGoogleVerified={setGoogleVerified}
          setIsLoading={setIsLoading}
          setOtpVerified={setOtpVerified}
          auth={auth}
          otpSent={otpSent}
        />
      ) : (
        <OtpVerification
          formValues={formValues}
          setFormValues={setFormValues}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          setOtpVerified={setOtpVerified}
          setIsLoading={setIsLoading}
        />
      );
    }

    switch (currentStep) {
      case 1:
        return (
          <>
            {renderSubscriptionPopup()}
            <PersonalInfoForm
              formValues={formValues}
              setFormValues={setFormValues}
              customSelectStyles={customSelectStyles}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              inputRefs={allInputRefs}
            />
            <div className="d-flex justify-content-end mt-1 mb-0">
              <button
                type="button"
                className="btn btn-primary"
                onClick={nextStep}
                onMouseOver={(e) => {
                  e.target.style.background = "#006600";
                  e.target.style.boxShadow =
                    "0 3px 6px rgba(108, 92, 231, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#6600CC";
                  e.target.style.boxShadow =
                    "0 2px 4px rgba(108, 92, 231, 0.3)";
                }}
              >
                Continue
              </button>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <EducationForm
              formValues={formValues}
              setFormValues={setFormValues}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              inputRefs={allInputRefs}
              customSelectStyles={customSelectStyles}
              careerLaunch={careerLaunch}
            />
            <div className="d-flex justify-content-between mt-2 gap-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={prevStep}
                onMouseOver={(e) => {
                  e.target.style.background = "#006600";
                  e.target.style.boxShadow =
                    "0 3px 6px rgba(108, 92, 231, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#6600CC";
                  e.target.style.boxShadow =
                    "0 2px 4px rgba(108, 92, 231, 0.3)";
                }}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={nextStep}
                onMouseOver={(e) => {
                  e.target.style.background = "#006600";
                  e.target.style.boxShadow =
                    "0 3px 6px rgba(108, 92, 231, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#6600CC";
                  e.target.style.boxShadow =
                    "0 2px 4px rgba(108, 92, 231, 0.3)";
                }}
              >
                Continue
              </button>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <EmploymentForm
              formValues={formValues}
              setFormValues={setFormValues}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              inputRefs={allInputRefs}
              careerLaunch={isCareerLaunch}
              customSelectStyles={customSelectStyles}
            />
            <AdditionalInfoForm
              formValues={formValues}
              setFormValues={setFormValues}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              setIsLoading={setIsLoading}
              navigate={navigate}
              resumeFile={resumeFile}
              setResumeFile={setResumeFile}
              inputRefs={allInputRefs}
              careerLaunch={careerLaunch}
              customSelectStyles={customSelectStyles}
              subscriptionData={subscriptionData} // Pass subscription data to AdditionalInfoForm
            />
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn-primary mt-n5 justify-content-between"
                onClick={prevStep}
                onMouseOver={(e) => {
                  e.target.style.background = "#006600";
                  e.target.style.boxShadow =
                    "0 3px 6px rgba(108, 92, 231, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#6600CC";
                  e.target.style.boxShadow =
                    "0 2px 4px rgba(108, 92, 231, 0.3)";
                }}
              >
                Back
              </button>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  if (isLoading) return <CLIFLoader />;

  return (
    <>
      <SEO />
      <main className="main-wrapper mt-5 pt-5">
        <HeaderFour />
        <div
          className="section section-padding"
          style={{
            backgroundImage:
              "url('../../assets/images/backgrounds/signup.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            paddingTop: "30px",
            paddingBottom: "30px",
          }}
        >
          <div className="container ">
            <div className="row justify-content-center">
              <div className="col-xl-10 col-lg-4">
                <div
                  className="contact-form-box shadow-lg"
                  style={{
                    overflow: "hidden",
                    marginTop: "0px",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div>
                    {renderStepIndicator()}
                    {renderFormByStep()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterOne />
      </main>
      <style jsx="true">{`
        textarea.form-control {
          height: auto;
          min-height: 100px;
        }
        .form-group {
          margin-bottom: 20px;
        }
        .form-section {
          border-radius: 10px;
          border: 1px solid #e9ecef;
          padding: 20px;
          margin-bottom: 25px;
          background-color: #ffffff;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.04);
          transition: all 0.3s ease;
        }
        .form-section:hover {
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
        }
        .text-red {
          color: #dc3545;
          font-size: 14px;
          margin-top: 5px;
          margin-bottom: 0;
        }
        label {
          font-weight: 500;
          color: #4a5568;
          margin-bottom: 8px;
          display: block;
        }
        .small-label {
          font-size: 14px;
          font-weight: 500;
          color: #4a5568;
        }
        .btn-primary {
          background: linear-gradient(135deg, #7928ca, #6600cc);
          border: none;
          box-shadow: 0 4px 12px rgba(102, 0, 204, 0.3);
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 500;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
        }
        .btn-primary:hover {
          background: linear-gradient(135deg, #8a3cd0, #7211d8);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(102, 0, 204, 0.35);
        }
        .btn-primary:active {
          transform: translateY(0);
        }
        .btn-outline-secondary {
          border-color: #7928ca;
          color: #7928ca;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 500;
          transition: all 0.3s ease;
        }
        .btn-outline-secondary:hover {
          background: #7928ca;
          color: white;
        }
        h3 {
          font-size: 32px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 16px;
        }
        h5 {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 24px;
          color: #4a5568;
        }
        select.form-control {
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%236B7280' viewBox='0 0 16 16'%3E%3Cpath d='M8 11.5l-4-4h8l-4 4z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 10px center;
          padding-right: 30px;
        }
        .step-indicator {
          margin-bottom: 30px;
        }
        .step-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #e9ecef;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
          color: #4a5568;
          font-weight: 500;
        }
        .step-circle.active {
          background: #7928ca;
          color: white;
        }
        .step-label {
          font-size: 14px;
          color: #4a5568;
        }

        /* Subscription Popup Styles */
        /* Subscription Popup Styles - Updated Design */
        .subscription-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 10000;
          animation: fadeIn 0.3s ease-out;
        }

        .subscription-popup {
          background: #fff;
          border-radius: 24px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 500px;
          width: 70%;
          height: 70%;
          padding: 20px;
          text-align: center;
          // position: relative;
          animation: slideIn 0.3s ease-out;
        }

        /* Circular Icon */
        .popup-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #7c4dff, #9c5aff);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          box-shadow: 0 8px 24px rgba(124, 77, 255, 0.3);
        }

        .sparkle-icon {
          font-size: 32px;
          color: white;
        }

        /* Title */
        .popup-title {
          font-size: 28px;
          font-weight: 700;
          color: #333;
          margin: 0 0 24px;
          letter-spacing: -0.5px;
        }

        /* Content */
        .subscription-popup-content {
          margin-bottom: 32px;
        }

        .plan-highlight {
          margin-bottom: 24px;
          padding: 20px;
          background: linear-gradient(135deg, #f8f9ff, #f0f0ff);
          border-radius: 16px;
          border: 1px solid #e6e6ff;
        }

        .plan-name {
          font-size: 20px;
          font-weight: 700;
          color: #7c4dff;
          margin-bottom: 8px;
        }

        .plan-price {
          font-size: 24px;
          font-weight: 800;
          color: #333;
          margin-bottom: 4px;
        }

        .plan-duration {
          font-size: 14px;
          color: #666;
          font-weight: 500;
        }

        .features-section-popup {
          margin-bottom: 20px;
        }

        .features-section-popup h6 {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 16px;
        }

        .features-list {
          display: grid;
          gap: 8px;
          text-align: left;
        }

        .feature-item-popup {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #555;
        }

        .feature-check-popup {
          color: #28a745;
          font-weight: bold;
          margin-right: 8px;
          flex-shrink: 0;
        }

        .completion-message {
          font-size: 16px;
          color: #666;
          line-height: 1.5;
          margin-bottom: 16px;
          font-weight: 400;
        }

        .payment-info {
          font-size: 14px;
          color: #7c4dff;
          margin-bottom: 0;
          font-weight: 500;
        }

        /* Action Buttons */
        .popup-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .btn-continue-registration {
          color: white;
          border: none;
          padding: 12px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 16px rgba(124, 77, 255, 0.3);
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 120px;
          justify-content: center;
        }

        .btn-continue-registration:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(124, 77, 255, 0.4);
        }

        .btn-cancel {
          background: #f8f9fa;
          color: #666;
          border: 1px solid #e9ecef;
          padding: 12px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 120px;
          justify-content: center;
        }

        .btn-cancel:hover {
          background: #e9ecef;
          border-color: #dee2e6;
          transform: translateY(-1px);
        }

        .sparkle-icon-small {
          font-size: 14px;
        }

        .cancel-icon {
          font-size: 16px;
        }

        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideIn {
          from {
            transform: translateY(-50px) scale(0.95);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .subscription-popup {
            width: 95%;
            height: 77%;
            margin: 20px;
            padding: 32px 24px 24px;
          }

          .popup-icon {
            width: 70px;
            height: 70px;
          }

          .sparkle-icon {
            font-size: 28px;
          }

          .popup-title {
            font-size: 24px;
          }

          .plan-name {
            font-size: 18px;
          }

          .plan-price {
            font-size: 20px;
          }

          .popup-actions {
            flex-direction: column;
            gap: 8px;
            margin-top: -20px;
          }

          .btn-continue-registration,
          .btn-cancel {
            width: 100%;
            padding: 14px 24px;
          }
        }

        /* Prevent body scroll when popup is open */
        .popup-open {
          overflow: hidden;
        }
      `}</style>
    </>
  );
};

export default SignUp;
